import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export function ProcedureSelect({ value, onChange, severity, onSeverityChange }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get('/catalog').then(r => setItems(r.data || []));
  }, []);
  const selected = items.find(i => i.id === value);
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <div>
        <label className="text-xs font-medium text-muted-foreground">Procedure (from catalog)</label>
        <Select value={value || 'none'} onValueChange={(v) => { const id = v === 'none' ? '' : v; const it = items.find(x => x.id === id); onChange(id, it?.name || ''); }}>
          <SelectTrigger data-testid="nurse-submission-procedure-select"><SelectValue placeholder="Select procedure" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none">— None / Manual entry —</SelectItem>
            {items.map(i => <SelectItem key={i.id} value={i.id}>{i.name} {i.icd10 ? `(${i.icd10})` : ''}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <label className="text-xs font-medium text-muted-foreground">Severity</label>
        <Select value={severity || 'Moderate'} onValueChange={onSeverityChange}>
          <SelectTrigger data-testid="nurse-submission-severity-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="Mild">Mild</SelectItem>
            <SelectItem value="Moderate">Moderate</SelectItem>
            <SelectItem value="Severe">Severe</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {selected && (
        <div className="md:col-span-2 rounded-lg bg-accent/50 border border-accent p-3 text-xs text-accent-foreground">
          <span className="font-medium">Catalog template:</span> Recovery {(selected.severity_variants || {})[severity || 'Moderate']?.recovery_weeks || '—'} weeks. {selected.follow_up_cadence}
        </div>
      )}
    </div>
  );
}
